if (!window.Eurus.loadedScript.has('custom-banner-cta.js')) {
  window.Eurus.loadedScript.add('custom-banner-cta.js');

  class BannerCtaShopButton extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('button');
      this.button?.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleClick);
    }

    handleClick() {
      const buyBox = document.querySelector('.product-info');
      buyBox?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  if (!customElements.get('banner-cta-shop-button')) {
    customElements.define('banner-cta-shop-button', BannerCtaShopButton);
  }
}
